function loadMoreProducts() {
 const loadMoreButton=document.getElementById('load-more');
 const button=loadMoreButton?.querySelector('button');
 const spinner=loadMoreButton?.querySelector('.loading__spinner');
 const buttonText=loadMoreButton?.querySelector('span');
 const productGrid=document.getElementById('product-grid');
 const paginationInfo=document.querySelector('.product-pagination-info');
 if(!button||!spinner||!buttonText||!productGrid||!paginationInfo)return;
 const initialPage=parseInt(new URLSearchParams(window.location.search).get('page'),10);
 let currentPage=initialPage>0?initialPage:1;
 let loading=false;
 button.addEventListener('click',async()=>{
  if(loading)return;loading=true;button.disabled=true;
  buttonText.style.display='none';spinner.classList.remove('hidden');
  const params=new URLSearchParams(window.location.search);params.set('page',currentPage+1);
  try{
   const response=await fetch(window.location.pathname+'?'+params.toString());
   if(!response.ok)throw new Error('Unable to load collection page');
   const doc=new DOMParser().parseFromString(await response.text(),'text/html');
   const newProducts=doc.querySelectorAll('#product-grid .product-item');
   const nextInfo=doc.querySelector('.product-pagination-info');
   if(!nextInfo)throw new Error('Collection pagination is missing');
   const total=parseInt(nextInfo.dataset.total,10);
   newProducts.forEach(item=>{productGrid.appendChild(item);addProdEvents(item);});
   currentPage++;
   const start=parseInt(paginationInfo.dataset.start,10)||1;
   const end=Math.min(start+productGrid.querySelectorAll('.product-item').length-1,total);
   paginationInfo.textContent=document.documentElement.lang==='vi'?'Đang xem '+start+' - '+end+' trên '+total+' sản phẩm':'Viewing '+start+' - '+end+' out of '+total+' products';
   const nav=document.querySelector('.mikenco-collection-pagination');
   const nextNav=doc.querySelector('.mikenco-collection-pagination');
   if(nav&&nextNav)nav.replaceWith(nextNav);else if(nav)nav.remove();
   if(!doc.querySelector('#load-more'))loadMoreButton.remove();
  }catch(error){
   console.error('Error loading more products:',error);
   const vi=document.documentElement.lang==='vi';
   buttonText.textContent=vi?'Thử lại':'Try again';
  }finally{loading=false;button.disabled=false;buttonText.style.display='inline';spinner.classList.add('hidden');}
 });
}
const addProdEvents=prod=>{
 const colors=prod.querySelector('.card__color-options');
 if(!colors||typeof initColorSelector!=='function')return;
 initColorSelector(colors.getAttribute('product-id'),undefined,prod.querySelector('.card__action product-form form'));
};
document.addEventListener('DOMContentLoaded',loadMoreProducts);
